module.exports = __webpack_public_path__ + "media/images/icons/tilde-45be97617994e9c5f1bc27470f8865b7.svg";